function handleErrors(res) {
  if (res.ok || res.status === 404) {
    return res;
  }
  // Best-effort: include status + response body so saga catch blocks have
  // enough context to attribute upstream failures (AT, deals-api gateway, etc.).
  return res
    .clone()
    .text()
    .catch(() => '')
    .then(body => {
      const err = new Error(
        `${res.statusText || 'Request failed'} (${res.status})${
          body ? `: ${body}` : ''
        }`
      );
      err.status = res.status;
      err.body = body;
      err.url = res.url;
      throw err;
    });
}

const getJson = _ => _.json();
const options = {
  accept: 'application/json'
};
const fetchJson = url =>
  fetch(url, options)
    .then(handleErrors)
    .then(getJson);

export const fetchResults = async (query, currentUrl) => {
  const params = new URLSearchParams(query);

  const standardMake = params.get('standardMake');
  const standardModel = params.get('standardModel');
  if (
    standardMake &&
    standardModel &&
    currentUrl &&
    currentUrl.includes('/car-leasing-deals')
  ) {
    const cheapestRequest = fetchJson(
      `/used-cars/api/results/query?facets=1&${query}&pageSize=1&currentUrl=${currentUrl}&Page`
    );
    const request = fetchJson(
      `/used-cars/api/results/query?facets=1&${query}&currentUrl=${currentUrl}`
    );

    try {
      const [cheapestResult, result] = await Promise.all([
        cheapestRequest,
        request
      ]);

      return { ...result, cheapestResult: cheapestResult };
    } catch (error) {
      console.error('Error fetching results:', error);
      throw error;
    }
  }

  try {
    const result = await fetchJson(
      `/used-cars/api/results/query?facets=1&${query}&currentUrl=${currentUrl}`
    );
    return { ...result, cheapestResult: [] };
  } catch (error) {
    console.error('Error fetching results:', error);
    throw error;
  }
};

export const fetchListing = (id, postCode) => {
  const url = postCode
    ? `/used-cars/api/listing/query?sourceId=${id}&postCode=${postCode}`
    : `/used-cars/api/listing/query?sourceId=${id}`;
  return fetchJson(url);
};

export const fetchMakes = currentUrl =>
  fetchJson(
    `/used-cars/api/results/query?facets=1&pageSize=0&currentUrl=${currentUrl}`
  );

export const fetchPostcode = postcode =>
  fetchJson(`/used-cars/api/postcode/query?code=${postcode}`);



// WEBPACK FOOTER //
// ./src/App/client/api/index.js